/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationDto } from '../../models/organization-dto';

export interface OrganizationsOwnerGet$Plain$Params {
}

export function organizationsOwnerGet$Plain(http: HttpClient, rootUrl: string, params?: OrganizationsOwnerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
  const rb = new RequestBuilder(rootUrl, organizationsOwnerGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationDto>>;
    })
  );
}

organizationsOwnerGet$Plain.PATH = '/organizations/owner';
